
(()=>{
  const keyvisual=document.querySelector(".section-keyvisual");
  if(keyvisual){
    const observer = new IntersectionObserver((entries)=>{
      entries.forEach(entry => {
        const kvBanner = document.querySelector('.keyvisual-top-banner')
        if (entry.isIntersecting) {
          document.body.dataset.scene=1;
          if(kvBanner) {
            kvBanner.classList.add("hide")
          }
        }else{
          if(entry.boundingClientRect.y>0){
            document.body.dataset.scene=0;
            if(kvBanner) {
              kvBanner.classList.remove("hide")
            }
          }
        }
      });
    }, {
      root: null,
      rootMargin: `${document.documentElement.scrollHeight}px 0px -50%`, // ビューポートの中心を判定基準にする
      threshold: [0]
    });
    observer.observe(keyvisual.querySelector('.waypoint'));

    const BrandLogo = document.querySelector(".brand-logo");
    keyvisual.insertAdjacentHTML("beforeend",'<div class="introLogo">'+BrandLogo.querySelector("svg").outerHTML+'</div>')
  }

  const natureItem = document.querySelector('.category-item.nature')
  const natureHolder = document.querySelector('.nature-holder')
  if(natureItem) {
    const natureObserver = new IntersectionObserver((entries)=>{
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          natureHolder.classList.add('show')
        }else{
          natureHolder.classList.remove('show')
        }
      });
    }, {
      root: null,
      rootMargin: "100% 0px",
      threshold: [0]
    });
    natureObserver.observe(natureItem);
  }

  if(natureHolder) {
    const footerObserver = new IntersectionObserver((entries)=>{
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          natureHolder.classList.add('covered')
        }else{
          natureHolder.classList.remove('covered')
        }
      });
    }, {
      root: null,
      rootMargin: "0px",
      threshold: [0]
    });
    footerObserver.observe(document.querySelector('.footer'));
  }
  

  const targes=[".scrAnim",".grid__item",".grid-item",".category-item",".article-card",".page-inner"].join(" , ")
  document.body.setAttribute("data-uk-scrollspy","target:"+targes+";cls:jsShow;delay:100;margin:10%;");
  document.body.classList.add("ready")

})()
